import { motion } from "framer-motion";

export function Section({ children, className = "", id, testid }) {
  return (
    <section id={id} data-testid={testid} className={`relative z-10 ${className}`}>
      {children}
    </section>
  );
}

export function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto max-w-[1400px] px-6 lg:px-10 ${className}`}>{children}</div>
  );
}

export function Eyebrow({ children }) {
  return <div className="overline">{children}</div>;
}

export function DisplayH1({ children, className = "" }) {
  return (
    <h1 className={`font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-[color:var(--wk-bone)] ${className}`}>
      {children}
    </h1>
  );
}

export function DisplayH2({ children, className = "" }) {
  return (
    <h2 className={`font-serif-display text-4xl md:text-5xl leading-[1.02] tracking-tight text-[color:var(--wk-bone)] ${className}`}>
      {children}
    </h2>
  );
}

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.19, 1, 0.22, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
